
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pk_rapport"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"delete_report_coreg"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pk_rapport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pk_rapport"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pk_rapport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_editeur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_annonceur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_support"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_emplacement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_campain"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"editeur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annonceur"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"support"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"emplacement"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"impression"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lead_brut"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lead_net"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prix_lead"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prix_client"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"campain"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mois"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"annee"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"etat"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"supprime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_modification"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_suppression"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":565}};
    doc.loc.source = {"body":"mutation(\n            $pk_rapport: Int\n        ) \n    {\n        delete_report_coreg(\n            pk_rapport: $pk_rapport\n        ) \n    { \n        pk_rapport\n        fk_editeur\n        fk_annonceur\n        fk_support\n        fk_emplacement\n        fk_campain\n        editeur\n        annonceur\n        support\n        emplacement\n        type\n        impression\n        lead_brut\n        lead_net\n        prix_lead\n        prix_client\n        campain\n        mois\n        annee\n        etat\n        supprime\n        date_modification\n        date_suppression\n    }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
